// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({
//   name: 'amountFormatter',
//   standalone: false
// })
// export class AmountFormatterPipe implements PipeTransform {

//   transform(value: string): string {
//
//     let V = value.split('.');
//    // console.log('v', V)
//     if (V.length > 1) {
//       let amount = parseFloat(value);
//
//       if (Math.round(amount) === amount) {
//
//         console.log('FloatAmount', amount.toFixed(3))
//         return amount.toFixed(3);
//       } else {
//
//         //     console.log('FloatAmount',amount.toFixed(3).replace(/\.?0*$/, ''))
//         console.log('FloatAmount', amount.toFixed(3))
//
//         return amount.toFixed(3);
//         // return amount.toFixed(3).replace(/\.?0*$/, '');

//       }
//     }
//     else {
//
//       let amount = Number(value);
//
//       if (Math.round(amount) === amount) {
//
//         // console.log('INTAmount',amount.toFixed(3))
//         return amount.toFixed(3);
//       } else {
//
//         return amount.toFixed(3).replace(/\.?0*$/, '');
//       }
//     }
//   }


// }

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amountFormatter',
  standalone: false
})
export class AmountFormatterPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    // Guard against null/undefined/empty values
    if (value === null || value === undefined || value === '') {
      return '0.000';
    }

    const strValue = String(value);
    const amount = parseFloat(strValue);

    // Guard against NaN
    if (isNaN(amount)) {
      return '0.000';
    }

    return amount.toFixed(3);
  }
}
